import styled from "styled-components";

export const CreateFieldStyled = styled.div`
  display: flex;
  justify-content: left;
  padding-top: 8px;
  padding-bottom: 32px;
  & > .selectBox {
    margin: 0 20px 20px 0px;
    min-height: 19px;
    width: 100%;
    max-width: 45%;
  }
`;

export const TopBarGroupStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  margin-bottom: 30px;
  margin-top: 15px;
`;

export const GroupPaginationStyled = styled.div`
  margin-top: -16px;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 16px;

  & > owc-pagination {
    justify-self: end;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    & > owc-pagination {
      justify-self: start;
    }
  }
`;
